
    <ul role="navigation">
      <li *ngFor="let node of nodes">
        <a class="nav-link" [class.highlight]="node.highlight" [href]="node.url" [title]="node.title">
          <span class="nav-link-inner">{{ node.title }}</span>
        </a>
      </li>
    </ul>